<template>
	<div class="slider">
		<Carousel
				:perPage="1"
				:navigationClickTargetSize="10"
				:paginationPadding="10">
			<Slide>
				<img src="@/assets/Slider-1.jpg">
			</Slide>
			<Slide>
				<img src="@/assets/Slider-2.jpg">
			</Slide>
			<Slide>
				<img src="@/assets/Slider-3.jpg">
			</Slide>
		</Carousel>
	</div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        name: 'slider',
        components: {
            Carousel,
            Slide
        },

        data() {
            return {
            };
        },


        mounted() {
        }
    }

</script>

<style lang="scss" scoped>

	.slider {
		padding: 5%;
		position: relative;
		height: auto;

		@media screen and (max-width: 768px) {
			padding: 10% 0;
		}

		.VueCarousel {
			.VueCarousel-inner {
				img {
					width: 100%;
				}
			}

		}
	}

</style>
